import { render, staticRenderFns } from "./EditAuth.vue?vue&type=template&id=c92f5c94&"
import script from "./EditAuth.vue?vue&type=script&lang=js&"
export * from "./EditAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92f5c94')) {
      api.createRecord('c92f5c94', component.options)
    } else {
      api.reload('c92f5c94', component.options)
    }
    module.hot.accept("./EditAuth.vue?vue&type=template&id=c92f5c94&", function () {
      api.rerender('c92f5c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/EditAuth.vue"
export default component.exports